export const dateTransform = (date) => {
  if (date == null) {
    return "";
  } else {
    date = date.split("T")[0].split("-");
    const normalDate = `${date[2]}.${date[1]}.${date[0]}`;
    return normalDate;
  }
};
